import { defineNuxtPlugin, useRuntimeConfig } from '#app'

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()

    return {
        provide: {
            nimbus: config.public.nimbus || {},
        },
    }
})
